import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

// =====================================================
// LIST
// =====================================================

export async function getFeedbacksApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("page", payload.page || 1);
    fd.append("limit", payload.limit || 10);
    fd.append("search", payload.search || "");
    fd.append("rating", payload.rating || "");
    fd.append("type", payload.type || "");
    fd.append("media", payload.media || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/feedbacks/list`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Feedbacks Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Feedbacks fetch failed",
    };
  }
}

// =====================================================
// STATS
// =====================================================

export async function getFeedbackStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/feedbacks/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Feedback Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Feedback stats fetch failed",
    };
  }
}

// =====================================================
// VIEW
// =====================================================

export async function getFeedbackApi(feedId) {
  try {
    const fd = new FormData();

    fd.append("feed_id", feedId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/feedbacks/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Feedback Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Feedback fetch failed",
    };
  }
}

// =====================================================
// CREATE
// =====================================================

export async function createFeedbackApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("feed_parent", payload.feed_parent || "");
    fd.append(
      "feed_parent_type",
      payload.feed_parent_type || ""
    );
    fd.append("feed_video", payload.feed_video || "");
    fd.append("feed_img", payload.feed_img || "");
    fd.append("feed_text", payload.feed_text || "");
    fd.append(
      "feed_meta_text",
      payload.feed_meta_text || ""
    );
    fd.append(
      "feed_keyword",
      payload.feed_keyword || ""
    );
    fd.append(
      "feed_rating",
      payload.feed_rating || ""
    );
    fd.append("feed_by", payload.feed_by || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/feedbacks/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Create Feedback Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Feedback creation failed",
    };
  }
}

// =====================================================
// UPDATE
// =====================================================

export async function updateFeedbackApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("feed_id", payload.feed_id || "");
    fd.append("feed_cat", payload.feed_cat || "");
    fd.append("feed_parent", payload.feed_parent || "");
    fd.append(
      "feed_parent_type",
      payload.feed_parent_type || ""
    );
    fd.append("feed_type", payload.feed_type || "");
    fd.append("feed_video", payload.feed_video || "");
    fd.append("feed_img", payload.feed_img || "");
    fd.append("feed_text", payload.feed_text || "");
    fd.append(
      "feed_meta_text",
      payload.feed_meta_text || ""
    );
    fd.append(
      "feed_keyword",
      payload.feed_keyword || ""
    );
    fd.append(
      "feed_rating",
      payload.feed_rating || ""
    );
    fd.append("feed_by", payload.feed_by || "");
   

    const res = await axios.post(
      `${apiBaseUrl}admin/feedbacks/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Update Feedback Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Feedback update failed",
    };
  }
}

// =====================================================
// DELETE
// =====================================================

export async function deleteFeedbackApi(feedId) {
  try {
    const fd = new FormData();

    fd.append("feed_id", feedId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/feedbacks/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Delete Feedback Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Feedback deletion failed",
    };
  }
}